
import { PageQuery } from '@/mixins/page_query';
import { Component, Mixins } from 'vue-property-decorator';
import { toast } from '@/utils/common';
import { eSearchStatus, iGameCountListModel, iGameCountListQuery } from '@/interface/room-manage';
import { getRoomGameCountList } from '@/api/room-manage';
@Component
export default class GameMarking extends Mixins(PageQuery) {
  loading: boolean = false;
  private query: iGameCountListQuery = {
    game_id: null,
    game_name: '',
  };
  tableData: iGameCountListModel[] = [];

  search() {
    this.page_query.page = 1;
    this.getSearchList();
  }

  async getSearchList() {
    try {
      this.loading = true;
      const res = await getRoomGameCountList({ ...this.page_query, ...this.query });
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  goDetail(row: iGameCountListModel) {
    this.$router.push({
      name: 'room-list',
      params: {
        game_id: JSON.stringify(row.game_id),
        game_name: row.game_name,
      },
    });
  }
  mounted() {
    this.pageFn = this.getSearchList;
    this.getSearchList();
  }
}
